import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { ValidationStatus } from '../../types/classDefinitionRepair';
import { getLocalTranslation } from '../../utils/i18nKit';
export var getValidationStatusMap = function getValidationStatusMap() {
  var _ref;

  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return _ref = {}, _defineProperty(_ref, ValidationStatus.CANCELLED, {
    value: ValidationStatus.CANCELLED,
    label: 'Cancelled'
  }), _defineProperty(_ref, ValidationStatus.DROPOUT, {
    value: ValidationStatus.DROPOUT,
    label: 'Dropout'
  }), _defineProperty(_ref, ValidationStatus.EXPIRED, {
    value: ValidationStatus.EXPIRED,
    label: 'Expired'
  }), _defineProperty(_ref, ValidationStatus.EXPIRE_SOON, {
    value: ValidationStatus.EXPIRE_SOON,
    label: 'Expire soon'
  }), _defineProperty(_ref, ValidationStatus.FAIL, {
    value: ValidationStatus.FAIL,
    label: 'Fail'
  }), _defineProperty(_ref, ValidationStatus.IMPORTED, {
    value: ValidationStatus.IMPORTED,
    label: 'Imported'
  }), _defineProperty(_ref, ValidationStatus.INVITATION_CREATED, {
    value: ValidationStatus.INVITATION_CREATED,
    label: 'Invitation created'
  }), _defineProperty(_ref, ValidationStatus.IN_PROGRESS, {
    value: ValidationStatus.IN_PROGRESS,
    label: 'In progress'
  }), _defineProperty(_ref, ValidationStatus.NOT_STARTED, {
    value: ValidationStatus.NOT_STARTED,
    label: 'Not started'
  }), _defineProperty(_ref, ValidationStatus.PAYE_CONTRACTOR, {
    value: ValidationStatus.PAYE_CONTRACTOR,
    label: 'PAYE contractor'
  }), _defineProperty(_ref, ValidationStatus.PENDING, {
    value: ValidationStatus.PENDING,
    label: 'Pending'
  }), _defineProperty(_ref, ValidationStatus.SUCCESS, {
    value: ValidationStatus.SUCCESS,
    label: 'Success'
  }), _defineProperty(_ref, ValidationStatus.URGENT_EXPIRING, {
    value: ValidationStatus.URGENT_EXPIRING,
    label: 'Urgent expiring'
  }), _ref;
};
export var getValidationStatusList = function getValidationStatusList() {
  return Object.values(getValidationStatusMap());
};